class ProductSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    // Wait for Swiper to be available (since it is loaded with defer)
    if (typeof Swiper === 'undefined') {
      setTimeout(() => this.initSwiper(), 50);
      return;
    }

    const swiperContainer = this.querySelector('.swiper');
    if (!swiperContainer) return;

    const isMobile = this.hasAttribute('data-mobile');
    const isDesktopThumbs = this.hasAttribute('data-desktop-thumbs');

    let config = {
      slidesPerView: 'auto',
      spaceBetween: 8,
      grabCursor: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      mousewheel: {
        forceToAxis: true,
      },
    };

    if (isMobile) {
      config = {
        ...config,
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
      };
    } else if (isDesktopThumbs) {
      config = {
        ...config,
        slidesPerView: 4,
        spaceBetween: 8,
        watchSlidesProgress: true,
      };
    }

    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
    }

    this.swiperInstance = new Swiper(swiperContainer, config);
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy();
    }
  }
}

if (!customElements.get('product-swiper')) {
  customElements.define('product-swiper', ProductSwiper);
}
